module.exports = __webpack_public_path__ + "static/media/credit-card.9b15957c.svg";